import { ProgressionSource } from "./progression-source";
import { ProgressionTieBreaker } from "./progression-tiebreaker";

export class Progression {
    id: number;
    rodeoId: number;
    toRodeoEventScheduleId: number;
    toRound: number;
    totalToProgress: number;
    alwaysFillTotal: boolean;
    progressMultipleTimes: boolean;
    cleanSlate: boolean;
    reverseCompetitionOrder: boolean;
    progressEachDivision: boolean;
    
    progressionSources: ProgressionSource[];
    tieBreakers: ProgressionTieBreaker[];
}


// WEBPACK FOOTER //
// ./src/model/progression.ts